import { useEffect, useState } from 'react';
import { IResultRequest } from '@vivli/features/results-request/infrastructure/interface';
import { first } from 'rxjs/operators';
import { useResultRequestApiContext } from '@vivli/core/infrastructure/context';

export function useResultRequests(requestId: string) {
    const [resultRequests, setResultRequests] = useState<IResultRequest[]>();

    const resultRequestService = useResultRequestApiContext();

    useEffect(() => {
        if (!requestId) {
            return;
        }

        resultRequestService.getResultRequests(requestId).pipe(first()).subscribe(setResultRequests);
    }, [requestId]);

    return {
        resultRequests,
        setResultRequests,
    };
}
